import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../../pages";
import type { FooterProps } from "../types";
import { FooterContent } from "./FooterContent";
import "./Footer.css";

export const Footer = (props: WithMetadata<FooterProps>) => {
  const {
    className,
    phoneNumber,
    openingHours,
    addresses,
    links,
    smallPrint,
    componentName,
    variant,
    ...otherProps
  } = props;

  const classes = classNames("mobius", "mobius-footer-gocompare", className);

  return (
    <footer
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      <FooterContent
        phoneNumber={phoneNumber}
        openingHours={openingHours}
        addresses={addresses}
      />
    </footer>
  );
};
